import { createFileRoute } from "@tanstack/react-router";

import HouseholdsList from "../components/HouseholdsList";

export const Route = createFileRoute("/")({
  component: HouseholdsList,
});
